import { httpGet } from './http'
import type { TContact } from '~/types/contact/models'
import { Contact } from '~/cynqueModules/dataObjects/Contact'

const apiEntityPath = '/api/contacts'

export async function getContacts({ apiPath = apiEntityPath } = {}) {
  const callingMn = getContacts.name
  return httpGet<TContact[]>({ callingMn, apiPath })
}

export async function getContactsPreProcessed({
  apiPath = apiEntityPath,
} = {}) {
  const callingMn = getContacts.name
  const rawContacts = await httpGet<TContact[]>({ callingMn, apiPath })
  return rawContacts.map((rawContact) => Contact(rawContact))
}
